<template>
    <div class="banner-back" >
        <template v-if="previousRoutesCount > 0">
            <TotemButton icon="arrow-left" color="secondary" @click="$router.go(-1)" :label="$t('General.go_back')" />
        </template>
        <template v-else>
            <router-link :to="getBackRoute()">
                <TotemButton icon="arrow-left" color="secondary">
                    {{ $t('General.go_back') }}
                </TotemButton>
            </router-link>
        </template>
    </div>
</template>

<script>
    import { NAMES } from '@/routes'
    import { mapGetters } from 'vuex'

    export default {
        name: 'totem-banner-back',
        computed: {
            packageSlug () {
                return this.$route.params.packageSlug
            },
            collectionSlug () {
                return this.$route.params.collectionSlug
            },
            learningPathSlug () {
                return this.$route.params.learningPathSlug
            },
            ...mapGetters({
                viewType: 'Search/getViewType'
            })
        },
        methods: {
            getBackRoute () {
                let backRouteName = 'collection-list'
                let backRouteParams = {}
                switch (this.$route.name) {
                case NAMES.COLLECTION_PAGE:
                    if (this.viewType === 'all') {
                        backRouteName = 'all-content'
                    }
                    backRouteParams = { packageSlug: this.packageSlug }
                    break
                case NAMES.COLLECTION_PAGE_WITHOUT_PACKAGE:
                    if (this.viewType === 'all') {
                        backRouteName = 'all-packages-all-content'
                    } else {
                        backRouteName = 'all-packages-collection-list'
                    }
                    break
                case 'course-without-package':
                    if (this.viewType === 'all') {
                        backRouteName = 'all-packages-all-content'
                    } else {
                        backRouteName = 'all-packages-course-list'
                    }
                    break
                case 'course-without-package-live':
                    if (this.viewType === 'all') {
                        backRouteName = 'all-packages-all-content'
                    } else {
                        backRouteName = 'all-packages-live-events'
                    }
                    break
                case 'course-without-package-virtual-classroom':
                    if (this.viewType === 'all') {
                        backRouteName = 'all-packages-all-content'
                    } else {
                        backRouteName = 'all-packages-virtual-classrooms'
                    }
                    break
                case 'course-list-course-page':
                    if (this.viewType === 'all') {
                        backRouteName = 'all-content'
                    } else {
                        backRouteName = 'course-list'
                    }
                    backRouteParams = { packageSlug: this.packageSlug }
                    break
                case 'course-list-course-page-live':
                    if (this.viewType === 'all') {
                        backRouteName = 'all-content'
                    } else {
                        backRouteName = 'live-events'
                    }
                    backRouteParams = { packageSlug: this.packageSlug }
                    break
                case 'course-list-course-page-virtual-classroom':
                    if (this.viewType === 'all') {
                        backRouteName = 'all-content'
                    } else {
                        backRouteName = 'virtual-classrooms'
                    }
                    backRouteParams = { packageSlug: this.packageSlug }
                    break
                case 'collection-page-course-page':
                case 'collection-page-course-page-live':
                case 'collection-page-course-page-virtual-classroom':
                    backRouteName = NAMES.COLLECTION_PAGE
                    backRouteParams = { packageSlug: this.packageSlug, collectionSlug: this.collectionSlug }
                    break
                case 'collection-page-course-page-without-package':
                case 'collection-page-course-page-live-without-package':
                case 'collection-page-course-page-virtual-classroom-without-package':
                    backRouteName = NAMES.COLLECTION_PAGE_WITHOUT_PACKAGE
                    backRouteParams = { collectionSlug: this.collectionSlug }
                    break
                case NAMES.LEARNING_PATH_PAGE_WITHOUT_PACKAGE:
                    if (this.viewType === 'all') {
                        backRouteName = 'all-packages-all-content'
                    } else {
                        backRouteName = 'all-packages-learning-paths'
                    }
                    break
                case NAMES.LEARNING_PATH_PAGE:
                    if (this.viewType === 'all') {
                        backRouteName = 'all-content'
                    } else {
                        backRouteName = 'learning-paths'
                    }
                    backRouteParams = { packageSlug: this.packageSlug }
                    break
                case 'learning-path-page-course-page':
                case 'learning-path-page-course-page-live':
                case 'learning-path-page-course-page-virtual-classroom':
                    backRouteName = NAMES.LEARNING_PATH_PAGE
                    backRouteParams = { packageSlug: this.packageSlug, learningPathSlug: this.learningPathSlug }
                    break
                case 'learning-path-course-page-without-package':
                case 'learning-path-course-page-live-without-package':
                case 'learning-path-course-page-virtual-classroom-without-package':
                    backRouteName = NAMES.LEARNING_PATH_PAGE_WITHOUT_PACKAGE
                    backRouteParams = { learningPathSlug: this.learningPathSlug }
                    break
                }
                if (this.viewType === 'home-courses') {
                    backRouteName = 'home-courses'
                }
                return { name: backRouteName, params: backRouteParams }
            }
        },
        data () {
            return {
                previousRoutesCount: 0
            }
        },
        created () {
            this.previousRoutesCount = window.sessionStorage.getItem('previousRoutesCount')
        }
    }
</script>

<style lang="scss" scoped>
.banner-back {
    display: flex;
    flex: 1;

    [class*="mobile"] & {
        margin: 0 auto;
    }
}
</style>
